const config = {
  name: "hawaii",
  features: {
    accessCodes: false,
    moreInformation: true,
    hasParkingInstructions: true,
    hasPromoCodeWarning: false,
    displayPromoTotalUses: false, // Display "Redemptions left" on promo code card
    mandatoryFields: false,
    userPhoneNumber: true,
    userName: false,
    showAdaSupport: false,
    userPostalCode: false
  },
  parkingSession: {
    // Until 5 PM
    cancelDaysBefore: 0,
    cancelTime: "17:00",
    cancelTimeOptions: [],
    // Start time offset from midnight, i.e. 12 am
    startOffsetHrs: 0,
    // Start date offset from today (0 = today) = no the same day reservations
    startOffsetDate: 0,
    // End date offset from start time
    endOffsetDate: 20
  }
}
export default config
